export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      // serviceContentsScreenSetting: {
      //   screenConfigMstId: 1,
      //   contentsScreenUuid: "contentsscreen001",
      //   screenName: "トップ画面",
      //   screenConfigName: "コミュニティサポート向けトップ画面",
      //   isHomeScreen: 1,
      //   isReleased: 1
      // },

      screenSettings: {
        // 画面名設定
        screenNameSetting: {
          screenCode: 'contentsscreen001',
          screenName: 'トップ画面',
          screenConfigName: 'コミュニティサポート向けトップ画面',
        },

        // ホーム画面設定
        isHomeScreen: false,

        // スライドショー設定
        screenSlideShowSettings: [
          {
            uuid: 'sc001_slideshow001',
            isDefaultFocusedFlg: 0,
            dropBoxFile: {
              serviceDropboxUuid: 'servicedropbox001',
              fileType: 3
            }
          },
          {
            uuid: 'sc001_slideshow002',
            isDefaultFocusedFlg: 1,
            dropBoxFile: {
              serviceDropboxUuid: 'servicedropbox002',
              fileType: 3
            }
          }
        ],

        // リストボタン（お知らせ/RSS）設定
        screenListBtnSettings: [
          {
            uuid: 'sc001_list001',
            listType: 1,
            noticeDeliveryType: ['family_info'],
            noticeDeliveryAttribute: 3,
            badgeColor: '#f00',
            badgeText: 'テキスト'
          },
          {
            uuid: 'sc001_list002',
            listType: 2,
            serviceRssUUIDs: ['servicerss002'],
            badgeColor: '#f00',
            badgeText: 'テキスト'
          }
        ],

        // ラベル設定
        screenLabelSettings: [
          {
            uuid: 'sc001_label003',
            labelText: 'ラベル名003'
          },
          {
            uuid: 'sc001_label002',
            labelText: 'ラベル名002'
          },
          {
            uuid: 'sc001_label001',
            labelText: 'ラベル名001'
          }
        ],

        // イメージ設定
        screenImageSettings: [
          {
            uuid: 'sc001_image001',
            imageFile: {
              fileName: "bg.gif",
              contentType: "image/gif",
              fileUri: "/images/img01.gif",
              fileSize: 1024,
              thumbnailUri: "/images/img01.gif"
            }
          }
        ],

        // ボタン設定
        screenBtnSettings: [
          {
            uuid: 'sc001_button003',
            btnSetting: {
              isDefaultFocusedFlg: 1,
              btnName: "button03",
              iconFile: {
                fileName: "bg.gif",
                contentType: "image/gif",
                fileUri: "/images/img01.gif",
                fileSize: 1024,
                thumbnailUri: "/images/img01.gif"
              },
              labelText: "show",
              btnActionType: 0,
              btnActionParameter: {
                screenCode: "contentsscreen001",
              },
              btnDisplayCondition: 1,
              btnDisplayParameter: {
                serviceRssUUIDs: []
              },
              isEnabled: true,
              badgeUseFlg: 1,
              badgeColor: "#f00",
              badgeText: "new",
              badgeDisplayCondition: 0,
              badgeDisplayParameter: {
                deliveryTypes: ["follow"],
              }
            }
          },
          {
            uuid: 'sc001_button001',
            btnSetting: {
              isDefaultFocusedFlg: 1,
              btnName: "button01",
              iconFile: {
                fileName: "bg.gif",
                contentType: "image/gif",
                fileUri: "/images/img01.gif",
                fileSize: 1024,
                thumbnailUri: "/images/img01.gif"
              },
              labelText: "show",
              btnActionType: 3,
              btnActionParameter: {
                dropBoxFile: {
                  serviceDropboxUuid: "servicedropbox002",
                  fileType: 2,
                }
              },
              btnDisplayCondition: 1,
              btnDisplayParameter: {
                serviceRssUUIDs: []
              },
              isEnabled: false,
              badgeUseFlg: 0,
              badgeColor: "#f00",
              badgeText: "new",
              badgeDisplayCondition: 0,
              badgeDisplayParameter: {
                deliveryTypes: ["follow"],
              }
            }
          },
          {
            uuid: 'sc001_button002',
            btnSetting: {
              isDefaultFocusedFlg: 1,
              btnName: "button02",
              iconFile: {
                fileName: "bg.gif",
                contentType: "image/gif",
                fileUri: "/images/img01.gif",
                fileSize: 1024,
                thumbnailUri: "/images/img01.gif"
              },
              labelText: "show",
              btnActionType: 4,
              btnActionParameter: {
                // screenCode: "servicecontents001",
                // webUrl: "xxxxx",
                // localFile: {
                // fileName: "bg.gif",
                //   contentType: "image/gif",
                //   fileUri: "/images/img01.gif",
                //   fileSize: 1024,
                //   thumbnailUri: "/images/img01.gif"
                // },
                // dropBoxFile: {
                //   serviceDropboxUuid: "xxxxxxx",
                //   fileType: 0,
                //   useType: 1
                // },
                launchSpApp: "app://csgycdi"
              },
              btnDisplayCondition: 1,
              btnDisplayParameter: {
                serviceRssUUIDs: []
              },
              isEnabled: true,
              badgeUseFlg: 1,
              badgeColor: "#f00",
              badgeText: "new",
              badgeDisplayCondition: 1,
              badgeDisplayParameter: {
                serviceRssUUIDs: ["servicerss002"]
              }
            }
          }
        ]
      }
    }
  }
}